import { Button } from "@caisy/league";
import { FCWithChildren } from "../../../interfaces/FCWithChildren";

interface IRegisterFormButton {
  loading?: boolean;
  disabled?: boolean;
}

export const RegisterFormButton: FCWithChildren<IRegisterFormButton> = ({ children, loading, disabled }) => {
  return (
    <Button disabled={disabled || loading} style={{ width: "100%" }} size="default" type="primary">
      {loading ? <img style={{ width: 24, height: 24 }} src={`/app/static-assets/spinner.gif`} /> : children}
    </Button>
  );
};
